import React from 'react';
import {imagePropsTitle, imageProps, limitTime} from './data';
import * as S from './style';
import {BreadCrumb, CardSection} from '../../../Components/Template';
import {Container, Image} from '../../../Components/Atom';
import {ContentTitle} from '../../../Components/Organism';

const Course = () => {
	return (
		<Container>
			<BreadCrumb depths={['HOME', '대회코스']} />
			<S.Container>
				<S.ImgWrapper>
					<ContentTitle {...imageProps.title} />
					<div style={{marginTop: '30px'}}></div>
					<S.CardWrapper>
						<Image {...imageProps.course} />
					</S.CardWrapper>
					{/* */}
					{/* 고저도 */}
					{/* <div style={{marginTop: '60px'}}></div>
					<ContentTitle {...imageProps.title1} />
					<div style={{marginTop: '30px'}}></div>
					<S.CardWrapper>
						<Image {...imageProps.course1} />
					</S.CardWrapper> */}
					{/* 고저도 */}
				</S.ImgWrapper>
				<S.CardWrapper>
					<CardSection {...limitTime} />
				</S.CardWrapper>
			</S.Container>
		</Container>
	);
};

export default Course;
